import { render, staticRenderFns } from "./UploadMediaModal.vue?vue&type=template&id=3166365a&"
import script from "./UploadMediaModal.vue?vue&type=script&lang=js&"
export * from "./UploadMediaModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadMediaModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports